<template>
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">{{ getLuJhuText() }}</span>
        </div>
      </div>
      <div class="content-8__titlebar__right">
        <DateFilterTab v-model="selectDate" />
      </div>
    </div>
    <TrendExplanation />
    <div class="content-8__controlbar">
      <CheckBoxButtons v-model="selectFilter" title="筛选号码" :filter-data="getFilterList" />
    </div>

    <div v-if="showLujhuInfo.length > 0 && !isLoading" class="content-8__content">
      <div v-for="(group, index) in showLujhuInfo" :key="index" class="luzhutable">
        <div class="luzhutable__head">
          <div class="luzhutable__head__left">
            <div class="luzhutable-group">
              <span class="head-text">连续出现</span>
              <div class="inputbox">
                <input :ref="`${group.field}-count`" class="inputbox__input" type="number" min="1" value="0">
              </div>
              <span class="head-text">次以上</span>
              <div class="selectbox">
                <select :ref="`${group.field}-type`" class="selectbox__select">
                  <option value="y">总来</option>
                  <option value="n">没来</option>
                </select>
              </div>
              <a class="button-primary active" @click.prevent="handleSortLight(group.field)">
                <span class="button-primary__text">确定</span>
              </a>
            </div>
            <div class="luzhutable-group">
              <span class="head-text">出现的次数:</span>
              <span :ref="`${group.field}-${group.ruleType}-value`" class="head-text">{{ getCount(`${group.field}-${group.ruleType}`) }}</span>
            </div>
          </div>
          <div class="luzhutable__head__right">
            <div class="luzhutable-group">
              <span class="head-text">今日累计:</span>
              <span>总来({{ group.totals['y'] }})</span>
              <span>没来({{ group.totals['n'] }})</span>
            </div>
            <div class="luzhutable-group">
              <span class="head-text red">{{ groupName(group.field) }}</span>
              <span class="head-text red">最新↓</span>
            </div>
          </div>
        </div>
        <div class="luzhutable-scroll">
          <div :ref="`${group.field}-${group.ruleType}`" class="luzhutable__content">
            <div
              v-for="(point, pointIndex) in group.roadBeads"
              :key="`point-${pointIndex}`"
              class="luzhutable__content__item"
              :class="handleHighlight(group.field, point)"
            >
              <div class="textbox">
                <div
                  v-for="(pointItem, pointItemIndex) in point"
                  :key="`point-item-${pointItemIndex}`"
                  class="textbox__item"
                  :class="textColor(pointItem)"
                >
                  <span class="textbox__item__text">{{ pointItem | itemName }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NoData v-if="showLujhuInfo.length === 0 && !isLoading" />
    <Loading v-if="isLoading" />
  </div>
</template>

<script>
import TrendExplanation from '@/components/web/pages/trend/TrendExplanation/index'
import { getRoadBallCount_mobile } from '@/api/mobile/roadball'
import DateFilterTab from '@/components/web/pages/trend/DateFilterTab'
import CheckBoxButtons from '@/components/web/common/CheckBoxButtons'
import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'

export default {
  name: 'HaoMaLuJhu',
  components: {
    DateFilterTab,
    Loading,
    NoData,
    CheckBoxButtons,
    TrendExplanation
  },
  filters: {
    // 球的名稱
    itemName(value) {
      switch (value) {
        case 'y':
          return '✔'
        case 'n' :
          return 'X'
        default:
          console.error('错误球名称')
          return value
      }
    }
  },
  props: {
    lotteryType: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {
      data: [],
      selectDate: '30',
      selectFilter: [],
      isLoading: false,
      hightlightObj: {}
    }
  },
  computed: {
    // 定義筛選器的裡面的值  号码路珠 (k3,kl10,ssc
    getFilterList() {
      switch (this.lotteryType) {
        case 'k3':
          return [
            { name: '号码1', val: 'num0' },
            { name: '号码2', val: 'num1' },
            { name: '号码3', val: 'num2' },
            { name: '号码4', val: 'num3' },
            { name: '号码5', val: 'num4' },
            { name: '号码6', val: 'num5' }
          ] // k3 6颗球
        case 'ssc':
          return [
            { name: '号码0', val: 'num0' },
            { name: '号码1', val: 'num1' },
            { name: '号码2', val: 'num2' },
            { name: '号码3', val: 'num3' },
            { name: '号码4', val: 'num4' },
            { name: '号码5', val: 'num5' },
            { name: '号码6', val: 'num6' },
            { name: '号码7', val: 'num7' },
            { name: '号码8', val: 'num8' },
            { name: '号码9', val: 'num9' }
          ] // ssc 9颗球
        default :
          return [
            { name: '号码1', val: 'num0' },
            { name: '号码2', val: 'num1' },
            { name: '号码3', val: 'num2' },
            { name: '号码4', val: 'num3' },
            { name: '号码5', val: 'num4' },
            { name: '号码6', val: 'num5' },
            { name: '号码7', val: 'num6' },
            { name: '号码8', val: 'num7' },
            { name: '号码9', val: 'num8' },
            { name: '号码10', val: 'num9' },
            { name: '号码11', val: 'num10' },
            { name: '号码12', val: 'num11' },
            { name: '号码13', val: 'num12' },
            { name: '号码14', val: 'num13' },
            { name: '号码15', val: 'num14' },
            { name: '号码16', val: 'num15' },
            { name: '号码17', val: 'num16' },
            { name: '号码18', val: 'num17' },
            { name: '号码19', val: 'num18' },
            { name: '号码20', val: 'num19' }
          ] // kl10 20颗球
      }
    },
    // 經過筛選條件之後要呈現的球組
    showLujhuInfo() {
      return this.data.filter((e) => this.selectFilter.includes(e.field))
    }
  },
  watch: {
    selectDate(newValue) {
      this.getInfo(newValue)
    },
    // 筛選條件變動，hightlightObj重製
    selectFilter() {
      this.initHightlightObj(this.data)
    }
  },
  created() {
    this.getInfo('30')
    // 初始載入，預設全選筛選條件
    if (this.lotteryType === 'k3') {
      this.selectFilter = ['num0', 'num1', 'num2', 'num3', 'num4', 'num5']
    } else if (this.lotteryType === 'ssc') {
      this.selectFilter = ['num0', 'num1', 'num2', 'num3', 'num4', 'num5', 'num6', 'num7', 'num8', 'num9']
    } else {
      this.selectFilter = ['num0', 'num1', 'num2', 'num3', 'num4', 'num5', 'num6', 'num7', 'num8', 'num9', 'num10', 'num11', 'num12', 'num13', 'num14', 'num15', 'num16', 'num17', 'num18', 'num19']
    }
  },
  methods: {
    async getInfo(value) {
      const result = {}
      if (/^\d{2}$/.test(value)) {
        result.count = value
      } else {
        result.date = value
      }

      this.isLoading = true

      const [data, error] = await getRoadBallCount_mobile({
        code: this.$route.params.lottery_code,
        rules: 'number',
        ...result
      })
      if (error) {
        console.error(`[error]:`, error)
        return
      }

      this.initHightlightObj(data)

      this.data = data
      this.isLoading = false
    },
    getLuJhuText() {
      return '号码路珠'
    },
    // 过滤资料球组名称
    groupName(value) {
      if (this.lotteryType === 'ssc') {
        switch (value) {
          case 'num0' :
            return '号码0'
          case 'num1' :
            return '号码1'
          case 'num2' :
            return '号码2'
          case 'num3' :
            return '号码3'
          case 'num4' :
            return '号码4'
          case 'num5':
            return '号码5'
          case 'num6':
            return '号码6'
          case 'num7':
            return '号码7'
          case 'num8':
            return '号码8'
          case 'num9':
            return '号码9'
          default:
            console.error('错误分组名称')
            return value
        }
      } else {
        switch (value) {
          case 'num0' :
            return '号码1'
          case 'num1' :
            return '号码2'
          case 'num2' :
            return '号码3'
          case 'num3' :
            return '号码4'
          case 'num4' :
            return '号码5'
          case 'num5':
            return '号码6'
          case 'num6':
            return '号码7'
          case 'num7':
            return '号码8'
          case 'num8':
            return '号码9'
          case 'num9':
            return '号码10'
          case 'num10' :
            return '号码11'
          case 'num11' :
            return '号码12'
          case 'num12' :
            return '号码13'
          case 'num13' :
            return '号码14'
          case 'num14' :
            return '号码15'
          case 'num15':
            return '号码16'
          case 'num16':
            return '号码17'
          case 'num17':
            return '号码18'
          case 'num18':
            return '号码19'
          case 'num19':
            return '号码20'
          default:
            console.error('错误分组名称')
            return value
        }
      }
    },
    // 球的顏色
    textColor(val) {
      switch (val) {
        case 'daxiao_da':
        case 'danshuang_shuang':
        case 'yanse_hong':
        case 'longHu_long':
        case 'y':
          return 'red'
        case 'yanse_lan':
          return 'blue'
        case 'yanse_lyu':
          return 'green'
        default:
          return ''
      }
    },
    // 添加 hightlight 的 class
    handleHighlight(ball, point) {
      if (
        point.length >= Number(this.hightlightObj[ball].split('-')[0]) &&
        point[0] === this.hightlightObj[ball].split('-')[1]
      ) {
        return 'hightlight'
      }
    },
    // 顯示 hightlight 的 條件
    handleSortLight(ball) {
      const count = `${ball}-count`
      const type = `${ball}-type`
      this.hightlightObj = Object.assign(this.hightlightObj, {
        [ball]: `${this.$refs[count][0].value}-${this.$refs[type][0].value}`
      })
    },
    // 計算 Hightlight 數量
    getCount(name) {
      this.$nextTick(() => {
        if (this.$refs[name]) {
          const childrenNodes = Array.from(this.$refs[name][0].children)
          const highLightItems = childrenNodes.filter((node) => {
            return node.className.includes('hightlight')
          })
          this.$refs[`${name}-value`][0].innerHTML = highLightItems.length
        } else {
          return 0
        }
      })
    },
    // 重置 Hightlight 注意[type.field] or [type.ruleType]
    initHightlightObj(data) {
      const hightLightInitObj = {}
      data.forEach((type) => {
        hightLightInitObj[type.field] = ''
      })
      this.hightlightObj = hightLightInitObj
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
